import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { CSSTransitionGroup } from 'react-transition-group';

import Button from 'components/button';
import Price from 'components/price';

export default class Modal extends Component {

  /* Lifecycle */

  constructor(props) {
    super(props);

    this.onBackdropClick = this.onBackdropClick.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
  }

  /* Handlers */

  onBackdropClick() {
    const { modals, appModalClose } = this.props;
    const { type, onCancel } = modals[modals.length - 1];

    if (type === 'confirm') onCancel();
    appModalClose();
  }

  onCancel() {
    const { modals, appModalClose } = this.props;
    const { onCancel } = modals[modals.length - 1];
    appModalClose();
    onCancel();
  }

  onConfirm(payload) {
    const { modals, appModalClose } = this.props;
    const { onConfirm } = modals[modals.length - 1];
    appModalClose();
    onConfirm(payload);
  }

  /* Render */

  render() {
    return (
      <CSSTransitionGroup
        transitionName="modal"
        transitionEnterTimeout={300}
        transitionLeaveTimeout={300}
      >
        {this.renderModal()}
      </CSSTransitionGroup>
    );
  }

  renderModal() {
    const { modals } = this.props;
    const modalNodes = [];

    modals.forEach((modal) => {
      const { id } = modal;
      let { type } = modal;

      if (!type) type = 'regular';

      modalNodes.push((
        <div className={`modal modal--${type}`} key={id}>
          <button
            className="modal__backdrop"
            onClick={this.onBackdropClick}
          />
          {this.renderContent(modal)}
        </div>
      ));
    });

    return modalNodes;
  }

  renderContent(modal) {
    const {
      component,
      dialogOverflow,
      fit,
      price,
      scrollDisabled,
      title,
      type,
    } = modal;

    let content = null;
    const { appModalClose } = this.props;

    const buttonClose = (
      <Button className="modal__button-close" onClick={appModalClose}>
        <span className="icon-close" />
      </Button>
    );

    const dialogClassNames = classNames('modal__dialog', {
      'modal__dialog--fit': fit,
      [`modal__dialog--overflow-${dialogOverflow}`]: dialogOverflow,
    });
    const contentClassNames = classNames('modal__content', { 'modal__content--no-scroll': scrollDisabled });

    let priceNode = null;

    if (price) {
      priceNode = (
        <div className="modal__header__price">
          <Price value={price} vatExcluded />
        </div>
      );
    }

    switch (type) {
      case 'fullscreen':
        content = component;
        break;

      case 'confirm':
        content = (
          <div className={dialogClassNames}>
            <div className="modal__header-wrapper">
              <div className="modal__header">
                <div className="modal__title">
                  {title}
                </div>
                {buttonClose}
              </div>
            </div>
            <div className={contentClassNames}>
              {component}
            </div>
            <div className="modal__actions-wrapper">
              <div className="modal__actions">
                <Button className="button button-border-yellow button-regular modal__button-action" onClick={this.onCancel}>
                  <FormattedMessage id="actions.cancel" />
                </Button>
                <Button className="button button-bg-yellow button-regular modal__button-action" onClick={this.onConfirm}>
                  <FormattedMessage id="actions.confirm" />
                </Button>
              </div>
            </div>
          </div>
        );
        break;

      default: {
        content = (
          <div className={dialogClassNames}>
            <div className="modal__header-wrapper">
              <div className="modal__header">
                <div className="modal__title">
                  {title}
                </div>
                {priceNode}
                {buttonClose}
              </div>
            </div>
            <div className={contentClassNames}>
              {component}
            </div>
          </div>
        );
      }
    }

    return content;
  }
}

Modal.propTypes = {
  appModalClose: PropTypes.func,
  modals: PropTypes.array,
};



// WEBPACK FOOTER //
// ./js/components/modal/index.jsx